module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av140-f5ff3eb54a44eb0fdb93b74f25202c07.jpg";